import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";
import { photoSrc } from "@/lib/format";
import { toast } from "sonner";
import { Upload, Image as ImageIcon, X, Link as LinkIcon } from "lucide-react";

export default function PhotoUpload({ value, onChange, label = "Foto", allowUrl = false, testid = "photo" }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [urlInput, setUrlInput] = useState("");

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setLoading(true);
    try {
      const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
      toast.success("Foto geüpload");
    } catch (e) { toast.error("Upload mislukt"); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <Label>{label}</Label>
      <div className="flex items-center gap-3 mt-1">
        <div className="h-20 w-20 rounded-lg border bg-slate-50 flex items-center justify-center overflow-hidden shrink-0">
          {value ? <img src={photoSrc(value)} alt="" className="h-full w-full object-cover" /> : <ImageIcon className="h-6 w-6 text-slate-300" />}
        </div>
        <div className="flex flex-col gap-2">
          <input ref={inputRef} type="file" accept="image/*" className="hidden" data-testid={`${testid}-input`} onChange={(e) => upload(e.target.files?.[0])} />
          <Button type="button" size="sm" variant="outline" onClick={() => inputRef.current?.click()} disabled={loading} data-testid={`${testid}-upload-btn`}>
            <Upload className="h-4 w-4 mr-2" /> {loading ? "Uploaden..." : "Uploaden"}
          </Button>
          {value && <Button type="button" size="sm" variant="ghost" className="text-red-500" onClick={() => onChange("")}><X className="h-4 w-4 mr-1" /> Verwijderen</Button>}
        </div>
      </div>
      {allowUrl && (
        <div className="flex gap-2 mt-2">
          <Input placeholder="of plak een foto-URL van internet" value={urlInput} onChange={(e) => setUrlInput(e.target.value)} data-testid={`${testid}-url-input`} />
          <Button type="button" size="sm" variant="outline" onClick={() => { if (urlInput.trim()) { onChange(urlInput.trim()); setUrlInput(""); toast.success("Foto-URL ingesteld"); } }}><LinkIcon className="h-4 w-4" /></Button>
        </div>
      )}
    </div>
  );
}
